import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PropertyDetailsService {
  private propertyIsSet: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public propertyIsSet$ = this.propertyIsSet.asObservable();
  private displayAddress = new BehaviorSubject<string>(''); // Observable string source
  public displayAddress$ = this.displayAddress.asObservable(); // Observable string stream

  public setProperty(newValue: boolean) {
    this.propertyIsSet.next(newValue);
  }

  public setDisplayAddress(newAddress: string) {
    this.displayAddress.next(newAddress);
  }
}
